import { Button, DialogActions, ListItemIcon, MenuItem, Popover, Typography } from '@mui/material';
import React, { FC } from 'react';
import IconButton from './IconButton';

type ConfirmPopoverProps = {
  text?: string | React.ReactNode;
  onConfirm: () => void;
  icon?: React.ReactNode;
  buttonText?: string;
  confirmText?: string;
  skipConfirm?: boolean;
  component?: 'IconButton' | 'MenuItem';
  color?: string;
  opacity?: number;
  size?: 'small' | 'medium' | 'large';
};

const ConfirmPopover: FC<ConfirmPopoverProps> = (props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | HTMLLIElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement | HTMLLIElement>) => {
    if (props.skipConfirm) {
      props.onConfirm();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'confirm-popover' : undefined;

  return (
    <>
      {props.component && props.component === 'MenuItem' ? (
        <MenuItem onClick={handleClick}>
          {props.icon && <ListItemIcon sx={{ color: props.color, opacity: props.opacity }}>{props.icon}</ListItemIcon>}
          {props.buttonText || 'Delete'}
        </MenuItem>
      ) : props.icon ? (
        <IconButton
          tooltip='Delete'
          aria-describedby={id}
          onClick={handleClick}
          sx={{ color: props.color, opacity: props.opacity }}
          size={props.size}
        >
          {props.icon}
        </IconButton>
      ) : (
        <Button
          aria-describedby={id}
          variant='contained'
          onClick={handleClick}
          sx={{ color: props.color, opacity: props.opacity }}
          size={props.size}
        >
          {props.buttonText || 'Open Popover'}
        </Button>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Typography sx={{ p: 2 }}>{props.text || 'Confirm action'}</Typography>
        <DialogActions>
          <Button variant='text' color='primary' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant='text'
            color='primary'
            onClick={() => {
              props.onConfirm();
              handleClose();
            }}
          >
            {props.confirmText || 'OK'}
          </Button>
        </DialogActions>
      </Popover>
    </>
  );
};

export default ConfirmPopover;
